import React from "react"
import { theme } from "../settings/config"

// In riga di testo e non flex: col dettaglio una pastiglia lunga va a capo
// come una frase, e con o senza dettaglio sono alte uguali.
const pill = {
	display: "inline-block",
	padding: "0.3rem 0.75rem",
	lineHeight: "1.15rem",
	borderRadius: "14px",
	fontSize: "0.8125rem",
	fontWeight: 600,
	whiteSpace: "nowrap",
}

// Gli stessi tre colori del foglio del contenuto: il tipo di giocatore
// arancione, i colpi pieni, le situazioni di gioco chiare
const PILL_STYLES = {
	playerStyle: { background: theme.colors.primary, color: theme.colors.white },
	stroke: { background: theme.colors.gunmetal_fill, color: theme.colors.white },
	situation: { background: theme.colors.gunmetal_lighter, color: theme.colors.gunmetal },
}

// Una voce del vocabolario tecnico (src/utils/lessonContent.utils.js) dove
// la si legge: nel contenuto della lezione e nella scheda dell'allievo.
// `detail` sono le voci scelte di una macroarea, quando non sono tutte:
// "Colpi a rimbalzo · Rovescio", con la seconda parte più leggera.
function ContentPill({ kind, children, detail, style }) {
	// col dettaglio può essere lunga: va a capo invece di uscire dallo schermo
	const wrap = detail ? { whiteSpace: "normal" } : {}
	return (
		<span style={{ ...pill, ...wrap, ...PILL_STYLES[kind], ...style }}>
			{children}
			{detail && <span style={{ fontWeight: 500, opacity: 0.85 }}> · {detail}</span>}
		</span>
	)
}

export default ContentPill
